function Tab({ selected, nrTabs, onClick, children, mobile = null }) {
  return (
    <div
      onClick={() => onClick()}
      className={` items-center w-1/2 pt-3 pb-1.5 pl-3 md:pl-4 text-sm md:text-base
    font-semibold select-none text-white relative
    ${mobile ? "flex md:hidden" : "flex"}
    ${nrTabs > 2 ? "first:rounded-tl-xl last:rounded-tr-xl" : "rounded-t-xl"}
      ${
        selected
          ? "bg-altblue-600 border-altblue-600"
          : "cursor-pointer bg-altblue-500 border-altblue-500 hover:text-altgray-300"
      } 
    }`}
    >
      {children}
    </div>
  );
}

function Tabs({ children, nrTabs }) {
  return (
    <div
      className={`flex w-full rounded-t-xl 
         bg-altblue-500 border-b-2 border-altblue-600 
         ${nrTabs > 2 ? "divide-x-2 divide-altblue-600" : ""}`}
    >
      {children}
    </div>
  );
}

Tabs.Tab = Tab;

export default Tabs;
